// extracted by mini-css-extract-plugin
module.exports = {"hero":"LandingPage_hero__tMthn","content":"LandingPage_content__3suVm","btn":"LandingPage_btn__yfylP","parrafe":"LandingPage_parrafe__3qz4N"};